module.exports = __webpack_public_path__ + "static/media/curriculumImg.2edd4812.jpg";